import type { ReceiptSession } from './types';

/**
 * True when the post-validate quality assessment flagged the source photo
 * as too poor to read reliably. Surfaced as an amber badge in the UI and
 * — because the parsed numbers can't be trusted — excluded from the
 * batch grand total in BatchProgress, the xlsx export, and the ZIP
 * summary sheet.
 */
export function isLowQualityPhoto(session: ReceiptSession): boolean {
  return session.findings.some((f) => f.kind === 'low_quality_photo');
}
